const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhotos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg12",
    width: "800px",
    height: "800px",
    fill: "#000000",
    viewBox: "0 0 31.06 32.001",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "photos",
    style: {
      fill: "#2b95d0",
      stroke: "#2b95d0"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "m12.41 7.7324c-1.3093.17519-1.7611 1.6394-1.896 2.7605-1.2521 5.1127-2.6208 10.198-3.729 15.345.061151 1.2799 1.461 1.8911 2.5716 1.9753 5.1777 1.2681 10.328 2.6518 15.54 3.7786 1.2772-.06897 1.8959-1.4581 1.9753-2.5736 1.2679-5.177 2.6529-10.326 3.7766-15.538-.05827-1.2798-1.4598-1.8929-2.5697-1.9791-5.2234-1.248-10.404-2.7262-15.669-3.7689zm.87109 1.6113c5.0479 1.2452 10.096 2.4999 15.131 3.791.93598.53438.53301 1.7644.26953 2.5703-.92632 3.6089-1.7383 7.2553-2.7812 10.828-.66621.87702-1.8461.30654-2.6875.11328-4.5232-1.1531-9.0806-2.1955-13.57-3.4648-.90334-.69665-.28181-1.9121-.092833-2.7864.90003-3.5091 1.7034-7.0479 2.7003-10.528.22002-.34289.62964-.53357 1.0312-.52344z",
    style: {
      fill: "#2b95d0",
      stroke: "#2b95d0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle4",
    cx: 15.587,
    cy: 14.069,
    r: 2.5266,
    style: {
      fill: "#fbcc62",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "m22.253 16.813c-.136-.418-.505-.51-.82-.205l-2.943 2.842c-.315.303-.759.244-.985-.133l-.471-.781c-.227-.377-.719-.5-1.095-.273l-4.782 2.852c-.377.225-.329.469.096.576l3.099.771c.426.107 1.122.281 1.549.389l3.661.912c.426.105 1.123.279 1.549.385l3.098.773c.426.107.657-.121.521-.539l-2.477-7.569z",
    style: {
      fill: "#2b95d0",
      stroke: "#2b95d0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "m17.559.50781c-5.3682 1.966-10.711 4.0126-16.005 6.1676-.82774.2903-1.2059 1.189-1.0035 2.0074.29595 1.2071.94899 2.2912 1.3072 3.4818 1.065 2.7661 2.13 5.5322 3.195 8.2983.35423-1.1293.73879-2.4458.043141-3.5362-1.0487-2.7391-2.1492-5.4637-3.0861-8.2392.076365-1.1575 1.4163-1.3986 2.2891-1.7305 4.2946-1.6584 8.584-3.3385 12.898-4.9395 1.0958-.077334 1.5323 1.1534 1.7676 2.0117.31315.82096.6263 1.6419.93945 2.4629.52665.08435 1.0087.33865 1.5312.34961-.85594-2.0066-1.3333-4.2404-2.623-6.0195-.36031-.25342-.81587-.37415-1.2539-.31445z",
    style: {
      fill: "#2b95d0",
      stroke: "#2b95d0"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotos);
export default __webpack_public_path__ + "static/media/photos.287e7b5316c848016894808100cf9894.svg";
export { ForwardRef as ReactComponent };